import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const SAFARI_IMAGE = 'https://images.unsplash.com/photo-1516426122078-c23e76319801';

export default function SafariBanner() {
  return (
    <section id="safari-banner" className="relative h-96 overflow-hidden flex items-center justify-center" style={{ backgroundImage: `url(${SAFARI_IMAGE})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
      <div className="absolute inset-0 bg-black/50"></div>
      <div className="relative z-10 text-center px-4 max-w-2xl">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 drop-shadow-lg">FAÇA SEU SAFARI EXCLUSIVO</h2>
        <p className="text-lg md:text-xl text-white/90 mb-8 drop-shadow-md">Viva a experiência única de um Safari de luxo na Savana Africana.</p>
        <Link to="/safari" className="inline-flex items-center gap-2 px-8 py-4 bg-accent hover:bg-accent/90 text-white font-bold rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg">
          CONHECER
          <ArrowRight size={20} />
        </Link>
      </div>
    </section>
  );
}
